<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :key="timeReload"
            key-property="noteId"
            search-url="/cropNotes/search"
            create-url="/cropNotes/save"
            delete-url="/cropNotes/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :isPagination="false"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
        >
        </c-search-form>
        <note-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :lst-disease="lstDisease"
            :lst-crop="lstCrop"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";
import { areaContants } from "@/constants";
import NoteCreate from "./NoteCreate";

export default {
    name: "warehouse",
    components: {NoteCreate, CSearchForm },
    data: () => {
        return {
            formName: "Sổ ghi chép",
            formCreateName: "Thêm ghi chép",
            category: null,
            visibleCreateDialog: false,
            timeReload: 0,
            lstDisease: [],
            lstCrop:[],
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "10%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "noteDate",
                    text: "Ngày ghi chép",
                    type:"date",
                    dateFormat:"dd/MM/yyyy",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    fromDate:"fromDate",
                    toDate:"toDate"
                },
                {
                    value: "cropCode",
                    text: "Mã vụ",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "shrimpAge",
                    text: "Tuổi tôm",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    contentStyle:"text-align:right"
                },
                {
                    value: "numberOfSeed",
                    text: "Số lượng giống",
                    type:"Number",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    contentStyle:"text-align:right"
                },
                {
                    value: "diseaseId",
                    text: "Tên bệnh",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: 'diseaseId',
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    sortable: false,
                    compound: true,
                    width: "60px",
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        // pondArea
        axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=DISEASES", {status: 1}
            )
            .then(
                (data) => {
                    if (data.length > 0) {
                        this.lstDisease = data;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "diseaseId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data;
                        }
                    }
                }
            );
        this.getCropList();
    },

    methods: {
        openCreateDialog: function (item = null) {
            if (item == null) {
                this.formCreateName = 'Thêm mới ghi chú';
            } else {
                this.formCreateName = 'Cập nhật ghi chú';
            }
            this.category = item;
            this.visibleCreateDialog = true;
        },
        closeCreateDialog: function () {
            this.category = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },

        getCropList() {
            axios.post(
                process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1&orderBy=asc", {
                    status: 1
                }
            ).then(
                (data) => {
                    if (data.items) {
                        this.lstCrop = data.items;
                    }
                }
            );

        },

    },

    destroyed() {},
};
</script>
